export default __webpack_public_path__ + "static/media/vezarat-rah.cf60e264.png";